import React from 'react';
import { useHistory } from 'react-router';
import doctor from "../../../../images/loginBg.png"

import "./bannersection.css";
const BannerSection = () => {


    const history = useHistory()
    const letsAppointment=()=>{ 
      history.push('/appointment')
    }




  return (
    <section className="banner_part">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-xl-7">
            <div className="banner_text">
              <div className="banner_text_iner">
                <h5>We are here for your care</h5>
                <h1>Best Care & Better Doctor</h1>
                <p>
                Your health remains our top priority!
Taking care of your health right now is the most important thing you can do for yourself and your family.
                </p>
                <button href="#" className="btn_2" onClick={letsAppointment}>
                  Make an appointment
                </button>
                {/* <a href="#" className="btn_2">
                  Make an appointment
                </a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="banner_img">
              {/* <img src="img/banner_img.png" alt="" /> */}
              <img src={doctor} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>



  );
};

export default BannerSection;
